const findArticleById = (cart, articleId) => {
    return cart.articles?.find(({ id }) => id === articleId);
};
const validateCartPayload = (payload, cartVersion) => {
    const hasOfferIds = !!payload.offerIds;
    const hasFlags = typeof payload.voucherApplied !== 'undefined' ||
        typeof payload.subscriptionSelected !== 'undefined';
    if (cartVersion === 'v1' && hasOfferIds && !hasFlags) {
        return 'Invalid Payload';
    }
    return null;
};
const convertCartToV1 = (cartV2) => {
    if (!cartV2)
        return cartV2;
    const cartV1 = { ...cartV2 };
    delete cartV1.deliveryDetails;
    delete cartV1.cartAutoshipment;
    delete cartV1.shipments;
    const cartV1Articles = cartV2.articles?.map((article) => convertCartArticleToV1(article)) || [];
    const cartV1Discounts = cartV2.discounts?.map((discount) => convertCartDiscountToV1(discount));
    const cartV1Fees = cartV2.fees?.map((fee) => convertCartFeeToV1(fee)) || [];
    const cartV1Summary = convertCartSummaryToV1(cartV2.summary);
    return {
        ...cartV1,
        articles: cartV1Articles,
        discounts: cartV1Discounts,
        fees: cartV1Fees,
        summary: cartV1Summary,
        selectedDeliveryCountry: cartV2.deliveryDetails?.selectedDeliveryCountry,
        selectedDeliveryCountryIsoCode: cartV2.deliveryDetails?.selectedDeliveryCountryIsoCode,
        deliveryZipCode: cartV2.deliveryDetails?.deliveryZipCode,
        cartSubscription: { ...(cartV2.cartAutoshipment || {}) },
    };
};
const convertCartArticleToV1 = (articleV2) => {
    const articleV1 = { ...articleV2 };
    delete articleV1.free;
    delete articleV1.savingsPlanArticle;
    delete articleV1.bonusArticle;
    delete articleV1.freeSample;
    delete articleV1.standardPriceArticle;
    delete articleV1.referencePrice;
    delete articleV1.lineItemDiscounts;
    delete articleV1.tooltip;
    const displayBeforePrices = !articleV2.free &&
        !articleV2.savingsPlanArticle &&
        !articleV2.bonusArticle &&
        !articleV2.freeSample &&
        !articleV2.standardPriceArticle;
    return {
        ...articleV1,
        shop_id: articleV2.shopId,
        price: articleV2?.price?.value,
        formattedPrice: articleV2?.price?.label,
        actualPrice: articleV2?.price?.value,
        formattedActualPrice: articleV2?.price?.label,
        actualPriceLabel: articleV2?.price?.labelFull,
        beforePrice: articleV2?.referencePrice?.value || articleV2?.price?.value,
        formattedBeforePrice: articleV2?.referencePrice?.label,
        beforePriceLabel: articleV2?.referencePrice?.labelFull,
        displayBeforePrices,
        priceType: convertPriceTypeToV1(articleV2?.priceType),
        voucherApplied: articleV2?.lineItemDiscounts?.articleBasedDiscount?.selected || false,
        voucherSelected: articleV2?.lineItemDiscounts?.articleBasedDiscount?.selected || false,
        subscriptionApplied: articleV2?.lineItemDiscounts?.autoshipmentDiscount?.applied || false,
        subscriptionSelected: articleV2?.lineItemDiscounts?.autoshipmentDiscount?.selected || false,
        subscriptionDetails: {
            displaySwitch: articleV2?.lineItemDiscounts?.autoshipmentDiscount?.displaySwitch,
            eligible: articleV2?.lineItemDiscounts?.autoshipmentDiscount?.eligible,
            firstOrderDiscount: articleV2?.lineItemDiscounts?.autoshipmentDiscount?.firstOrderDiscount,
            percentage: articleV2?.lineItemDiscounts?.autoshipmentDiscount?.percentage,
        },
        articleBasedVoucher: convertABDToV1(articleV2?.lineItemDiscounts?.articleBasedDiscount),
        tooltipTextKey: '',
        localizedTooltipText: articleV2?.tooltip?.text,
        percentageDiscount: articleV2?.tooltip?.percentageDiscount,
    };
};
const convertCartDiscountToV1 = (discountV2) => {
    if (!discountV2)
        return discountV2;
    const discountV1 = { ...discountV2 };
    delete discountV1.couponDetails;
    return {
        ...discountV1,
        absolute_discount: discountV2.absoluteDiscount,
        percentage_discount: discountV2.percentageDiscount,
        couponCode: discountV2.couponDetails?.couponCode,
        couponId: discountV2.couponDetails?.couponId,
        sel_code: discountV2.couponDetails?.selCode,
        selCode: discountV2.couponDetails?.selCode,
        couponValid: discountV2.couponDetails?.couponValid,
        couponActive: discountV2.couponDetails?.couponActive,
        productGroupBased: discountV2.couponDetails?.productGroupBased,
        freeShipping: discountV2.couponDetails?.freeShipping,
        restrictions: [],
    };
};
const convertCartFeeToV1 = (feeV2) => {
    if (!feeV2)
        return feeV2;
    return {
        ...feeV2,
        absolute_price: feeV2.absolutePrice,
        percentage_price: feeV2.percentagePrice,
    };
};
const convertCartSummaryToV1 = (summaryV2) => {
    if (!summaryV2)
        return summaryV2;
    return {
        ...summaryV2,
        grand_total: summaryV2.grandTotal ? `${summaryV2.grandTotal}` : undefined,
    };
};
const convertPriceTypeToV1 = (type) => {
    if (!type)
        return 'standard';
    const priceTypeMap = {
        OFFER: 'standard_reduced',
        REGULAR: 'standard',
        RETAIL: 'supplier_reduced',
        SET: 'set_article',
    };
    return priceTypeMap[type];
};
const convertABDToV1 = (abdV2) => {
    if (!abdV2)
        return abdV2;
    const abdV1 = { ...abdV2 };
    delete abdV1.type;
    delete abdV1.value;
    delete abdV1.label;
    return {
        ...abdV1,
        voucherId: 1,
        voucherType: abdV2.type,
        voucherValue: abdV2.value,
        voucherLabel: abdV2.label,
        priceBeforeDiscount: undefined,
    };
};
const extractVersionFromCart = (cart) => {
    if (cart?.shipments) {
        return 'v2';
    }
    return 'v1';
};

export { convertABDToV1, convertCartArticleToV1, convertCartDiscountToV1, convertCartFeeToV1, convertCartSummaryToV1, convertCartToV1, convertPriceTypeToV1, extractVersionFromCart, findArticleById, validateCartPayload };
//# sourceMappingURL=cartUtils.js.map
